import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  H5,
  H6,
} from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { Icon } from "../../components";
import { AddressFragment } from "../../components/addressFragment/AddressFragment";
import { OrderCreateConsignmentUpdateSupplierDetailsModal } from "../../components/newOrderSummary/OrderCreateConsignment/OrderCreateConsignmentUpdateSupplierDetailsModal";
import { useRemoteFeatureFlags } from "../../hooks/useRemoteFeatureFlags";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";

export function CollectionContactDetails({
  canEdit,
}: {
  canEdit?: boolean;
}): ReactElement {
  const { business } = useSellarCurrentBusiness();
  const [supplierUpdateActive, setSupplierUpdateActive] =
    useState<boolean>(false);
  const collectionAddressEnabled = useRemoteFeatureFlags().isActive(
    "collectionAddressCreation",
  );

  const collectionAddress =
    collectionAddressEnabled && business?.CollectionAddress
      ? business.CollectionAddress
      : business?.DeliveryAddress;
  return (
    <>
      <Card className="bg-white">
        <CardHeader
          className={twMerge(
            "bg-white",
            "flex items-center justify-between p-4",
          )}
        >
          <div className="flex flex-col">
            <H5>Your Contact Info</H5>
            <H6>
              The email address & phone number you provide will receive
              notifications about your collection.
            </H6>
          </div>
          {canEdit && (
            <Button
              color={"secondary"}
              onClick={() => setSupplierUpdateActive(true)}
            >
              <Icon icon={"PENCIL"} />
              Edit
            </Button>
          )}
        </CardHeader>
        <CardContent className={"p-4"}>
          <div className="grid md:grid-cols-2">
            <div className="col-span-1 flex flex-col">
              <div className="flex gap-2">
                <H5>Collection address</H5>
              </div>
              {collectionAddress && (
                <AddressFragment address={collectionAddress} />
              )}
            </div>
            <div className="col-span-1 flex flex-col gap-2">
              <div className="">
                <div className="flex gap-2">
                  <H5>Email Address</H5>
                </div>
                <H6>{business?.email}</H6>
              </div>
              <div className="">
                <div className="flex gap-2">
                  <H5>Phone number</H5>
                </div>
                <H6>{business?.phoneNumber}</H6>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      {business?.Supplier && canEdit && (
        <OrderCreateConsignmentUpdateSupplierDetailsModal
          onDismiss={() => setSupplierUpdateActive(false)}
          active={supplierUpdateActive}
          email={business.email}
          phoneNumber={business.phoneNumber}
          businessId={business.id}
        />
      )}
    </>
  );
}
